// employee-frontend/src/features/queryResponses/queryResponseSlice.js
import { createSlice } from '@reduxjs/toolkit';
import { createQueryResponseThunk } from './queryResponseThunks';

const initialState = {
  loading: false,
  error: null,
};

const queryResponseSlice = createSlice({
  name: 'queryResponses',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createQueryResponseThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createQueryResponseThunk.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(createQueryResponseThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to create query response';
      });
  },
});

export default queryResponseSlice.reducer;
